import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import {i18n} from './i18n';
import '@/registerServiceWorker';
import moment from 'moment';
import webmms from "webmms-client";
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import conf from '@/config/config';

const opts = {
  icons: {
    iconfont: 'md', // default - only for display purposes
  },
};

Vue.config.productionTip = false
Vue.use(Vuetify);

Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD - HH:mm:ss A')
  }
});


Vue.prototype.makeId = function(length){
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

Vue.prototype.$mms = webmms({
  //wsurl: "https://ws1.ypcloud.com",
  wsurl: process.env.NODE_ENV == 'production'?window.location.hostname:"https://ws1.ypcloud.com",
  EiToken: getCookie("obj-EiToken") || "",
  SToken: getCookie("obj-SToken") || ""
});

new Vue({
  vuetify : new Vuetify(opts),
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
